module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/ChevronLeft-571f6680ee561ae05a1e637c69334655.png";